export default __webpack_public_path__ + "static/media/meet-the-toys.c508e11b.png";